import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import Warning from '@/assets/icons/select-no-options.svg?react';
import WarningSecondary from '@/assets/icons/warning-icon.svg?react';
import ErrorIcon from '@/assets/icons/error-icon.svg?react';
import InfoIcon from '@/assets/icons/alert-info-icon.svg?react';
import Success from '@/assets/icons/success-icon.svg?react';
import clsx from 'clsx';
import { Palette } from '@/themes/themeOverrides/Palette';

const iconMap = {
    info: <InfoIcon />,
    success: <Success />,
    error: <ErrorIcon />,
    warning: <Warning />,
    warningSecondary: <WarningSecondary />,
};

const NotificationBox = ({ variant = 'info', icon, children, className = '' }) => {
    return (
        <Box
            className={clsx('notification-box', `variant-${variant}`, className)}
            sx={{
                margin: '20px',
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                padding: '16px',
                borderRadius: '8px',
                backgroundColor: {
                    info: Palette.blue.blue50,
                    success: Palette.green.green50,
                    error: Palette.red.red50,
                    warning: Palette.yellow.yellow50,
                    warningSecondary: Palette.yellow.yellow50,
                }[variant],
                '& .notification-icon': {
                    display: 'flex',
                    marginRight: '12px',
                },
                '& .MuiTypography-root': {
                    fontSize: '14px',
                    fontWeight: '400',
                    color: Palette.black,
                },
                '&.large': {
                    margin: '0px',
                    width: '100%',
                    boxSizing: 'border-box',
                    padding: '20px',
                    borderRadius: '16px',
                },
            }}
        >
            <Box className='notification-icon' sx={{ color: '#666' }}>
                {icon ?? iconMap[variant]}
            </Box>
            <Typography component='div'>{children}</Typography>
        </Box>
    );
};

export default NotificationBox;

NotificationBox.propTypes = {
    variant: PropTypes.oneOf(['info', 'success', 'error', 'warning', 'warningSecondary']),
    icon: PropTypes.node,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};
